/**Variables de Entorno */
const URL_IMAGES: string = process.env.REACT_APP_URL_IMAGES ?? '';

const ErrorImage: string = `${URL_IMAGES}/static/image-error.jpg`;

export default ErrorImage;
